import YouTubePlayer from 'youtube-player';
import Component from '../../../scripts/utilities/component';

class HeroVideoPlayer extends Component {
    componentDidMount() {
        const htmlTag = document.getElementsByTagName('html')[0];
        this.htmlTag = htmlTag;
        this.videoPoster = this.root.querySelector('[data-ref="video-poster"]');
        this.playButton = this.root.querySelector('[data-ref="play-button"]');
        this.closeButton = this.root.querySelector('[data-ref="close-button"]');
        this.ytVideo = this.root.querySelector('[data-ref="yt-video"]');
        this.ytVideoID = this.ytVideo.getAttribute('data-video-id');
        this.params = {};

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.playButton.addEventListener('click', this.handleVideoClick.bind(this), true);

        this.closeButton.addEventListener(
            'click',
            (e) => {
                e.preventDefault();
                if (this.player) {
                    this.player.pauseVideo();
                }
            },
            true
        );

        document.addEventListener(
            'keyup',
            (event) => {
                const { key, keyCode } = event;
                if (key.toLowerCase() === 'escape' || keyCode === 27) {
                    if (this.player) {
                        this.player.pauseVideo();
                    }
                }
            },
            true
        );
    }

    handleVideoClick(e) {
        e.preventDefault();

        if (this.root.classList.contains('is--loaded')) {
            this.player.playVideo();
        } else {
            this.setUpPlayer();
        }
    }

    setUpPlayer() {
        this.videoPoster.remove();

        this.player = new YouTubePlayer(this.ytVideo, {
            videoId: `${this.ytVideoID}`,
            playerVars: {
                autoplay: 1,
                controls: 0,
                disablekb: 0,
                enablejsapi: 1,
                loop: 0,
                modestbranding: 1,
                playsinline: 0,
                rel: 0,
                showinfo: 0,
                color: 'white',
                iv_load_policy: 3
            }
        });

        this.root.classList.add('is--full-screen', 'is--loaded');

        this.player.on('stateChange', (event) => {
            // Stop
            if (event.data === 0) {
                this.root.classList.remove('is--full-screen');
                this.htmlTag.classList.remove('no-scroll');
                this.root.classList.add('is--complete');
            }

            // Pause
            if (event.data === 2) {
                this.root.classList.remove('is--full-screen');
                this.htmlTag.classList.remove('no-scroll');
                this.root.classList.add('is--paused');
            }

            // Play
            if (event.data === 1) {
                this.root.classList.remove('is--complete', 'is--paused');
                this.root.classList.add('is--full-screen');
                this.htmlTag.classList.add('no-scroll');
            }
        });
    }
}

export default HeroVideoPlayer;



// WEBPACK FOOTER //
// ./components/eng-ms-squad-hero/scripts/hero-video-player.js